import { CSSProperties } from 'react';
import styled from 'styled-components';

import Box from '../Global/Atomics/Box';
import { Container } from '../Global/Atomics/Container';
import CustomIcon from '../Global/Icons/CustomIcon';
import Theme from '../../styles/Theme/Theme';

type TSCustomProps = {
    customColor?: keyof typeof Theme.color;
    bg?: keyof typeof Theme.color;
    pt?: keyof typeof Theme.spacing;
};

const BottomBorder = styled(Box) <CSSProperties & TSCustomProps>`
    background-color: ${({ backgroundColor, bg, theme }) => {
        if (bg) return theme.color[bg];
        return backgroundColor;
    }};
    border-bottom: 5px solid ${({ theme, customColor }) => (customColor ? theme.color[customColor] : '#000')};
    margin-top: auto;
`;

export const Footer = ({ backgroundColor, pt }: CSSProperties & TSCustomProps) => {
    return (
        <BottomBorder as="footer" id="main-footer" backgroundColor={backgroundColor ? backgroundColor : "transparent"} customColor="green-deloitte">
            <Container>
                <Box pt={pt ? pt : 'xl'} pb="lg">
                    <CustomIcon icon="BrandLogo" width={100} height={35} />
                </Box>
            </Container>
        </BottomBorder>
    );
};
